import posthog from "posthog-js";

export const getPostHog = () => {
  return posthog;
};
